import { FEATURE_AVAILABILITY_MAP, PlanFeature, SubscriptionPlan } from "@/constants/plans";

interface IsPlanFeatureEnabledProps {
  feature: PlanFeature;
  plan: SubscriptionPlan | null | undefined;
}

export function isPlanFeatureEnabled({ feature, plan }: IsPlanFeatureEnabledProps): boolean {
    if (!plan) return false;
  
    const allowedPlans = FEATURE_AVAILABILITY_MAP[feature];

    return allowedPlans.includes(plan);
  }